import { Layout, MTools } from "@/components";
import { getTopicList, getDictList, getActivityList } from "@/services/service";
import React, { Component } from "react";
import styles from "./index.less";
import BetterScroll from "@better-scroll/core";
import { RouteComponentProps, withRouter } from "dva/router";
import PullUp from "@better-scroll/pull-up";
import { IMedia } from "@/models/types/media";
import { createRef } from "react";
import classnames from "classnames";

interface CloudClassroomProps {}
interface CloudClassroomState {
  current: number;
  list: IMedia[];
  size: number;
  total: number;
  loading: boolean;
  hasMore: boolean;
  tabIndex: number | string;

  typeData: any[];
}
type CloudClassroomInfo = CloudClassroomProps & RouteComponentProps;

BetterScroll.use(PullUp);

class CloudClassroom extends Component<
  CloudClassroomInfo,
  CloudClassroomState
> {
  indexRef: any;
  bs: any;
  constructor(props: CloudClassroomInfo) {
    super(props);
    this.state = {
      current: 1,
      list: [],
      size: 10,
      total: 0,
      loading: false,
      hasMore: true,

      tabIndex: "",
      typeData: [],
    };
    this.indexRef = createRef();
  }

  componentDidMount() {
    this.getData();
    this.getTopicList();
  }

  // 获取专题列表（检索”网络安全云课堂“）
  getTopicList = async () => {
    const result = await getTopicList({});
    if (result.success) {
      const topicId =
        result.data.filter((item: any) => item.title === "网络安全云课堂")?.[0]
          ?.id ?? null;
      if (topicId) {
        this.getDetail(topicId);
      }
    } else {
      MTools.Tips(
        "error",
        (result && result.message) || "系统异常，请刷新再试"
      );
    }
  };

  // 获取分类据
  getData = async () => {
    if (!this.state.hasMore) return;
    this.setState({
      loading: true,
    });
    const result = await getDictList({
      dictTypeValue: "onlineCourseType",
    });
    if (result.success) {
      this.setState(
        {
          typeData: result.data,
        },
        () => {}
      );
    } else {
      MTools.Tips(
        "error",
        (result && result.message) || "系统异常，请刷新再试"
      );
    }

    this.setState({
      loading: false,
    });
  };

  // 获取活动数据
  getDetail = async (topicId: string) => {
    const result = await getActivityList({
      topicId,
      status: 1
    });
    if (result.success) {
      console.log(result);
      this.setState({
        list: result.data,
      });
    } else {
      MTools.Tips(
        "error",
        (result && result.message) || "系统异常，请刷新再试"
      );
    }
  };

  onTabs = (i: string) => {
    this.setState({
      tabIndex: i,
    });
  };

  render() {
    const { typeData, tabIndex, list } = this.state;
    return (
      <div className={styles.index} ref={this.indexRef}>
        <Layout padding={23}>
          <div className={styles.wrap}>
            <div className={styles.wrap_header}>
              <div
                className={classnames(
                  styles.wrap_header_item,
                  tabIndex == "" ? styles.active : null
                )}
                onClick={() => this.onTabs("")}
              >
                全部
              </div>
              {typeData.map((item, i) => {
                return (
                  <div
                    key={i}
                    className={classnames(
                      styles.wrap_header_item,
                      tabIndex == item.value ? styles.active : null
                    )}
                    onClick={() => this.onTabs(item.value)}
                  >
                    {item.name}
                  </div>
                );
              })}
            </div>
            <div className={styles.wrap_center}>
              {  list.filter(item => item.dictValue == tabIndex || tabIndex == '').map((items, i) => {
                return (
                  <div
                    className={styles.card}
                    onClick={() =>
                      this.props.history.push(
                        `/app/cloudClassroomDetail/${items.id}`
                      )
                    }
                  >
                    <div className={styles.card_img}>
                      <img src={items.cover} alt="" />
                    </div>
                    <div className={styles.card_title}>
                      <div className={styles.card_title_text}>{items.title}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

export default withRouter(CloudClassroom);
